import { FC, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { useAccount, useDisconnect } from "wagmi";

import { shortAddress } from "app/utils/shortAddress";
import { setUserManuallyDisconnected } from "app/hooks/useConnect";
import { ReactComponent as CopyBtn } from "assets/img/icons/copyBtn.svg";
import { ReactComponent as LogoutBtn } from "assets/img/icons/logoutBtn.svg";
import { ReactComponent as Metamask } from "assets/img/icons/metamask.svg";
import tokenService from "services/token.service";
import styles from "./wallet-widget.module.scss";

interface WalletWidgetProps {
  closeMenu?: () => void;
}

declare global {
  interface Window {
    gtagEventConnectWalletClicked?(data: string): void;
    claimr: Claimr | undefined;
  }

  interface Claimr {
    logout: () => void;
    connect_wallet: (
      address: string,
      signature: string,
      message: string
    ) => void;
  }
}

const WalletWidget: FC<WalletWidgetProps> = ({ closeMenu }) => {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const [copied, setCopied] = useState(false);

  // Removed duplicate authentication logic - this is now handled in header-connect.tsx

  const onConnectClick = (): void => {
    onClickGtagConnectWallet();

    if (closeMenu) {
      closeMenu();
    }
  };

  function onClickGtagConnectWallet() {
    window.gtagEventConnectWalletClicked &&
      window.gtagEventConnectWalletClicked("Connect Wallet");
  }

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(address || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDisconnect = () => {
    // Set flag to prevent auto-reconnect
    setUserManuallyDisconnected(true);

    // Clear auth tokens
    tokenService.removeToken();
    localStorage.removeItem("signature");

    // Disconnect wallet
    disconnect();
    window.claimr?.logout();
  };

  return (
    <div className={styles.wallet}>
      <div className={styles.walletInner}>
        <div className={styles.walletWapper}>
          {/* <Link to={Path.ACCOUNT}> */}
          <div onClick={handleCopyAddress} className={styles.logoWrapper}>
            <Metamask />
            {shortAddress(address)}
          </div>
          {/* </Link> */}
          <button onClick={handleCopyAddress}>
            {copied ? <AiOutlineCheck color="#fff" /> : <CopyBtn />}
          </button>
        </div>
        <button onClick={handleDisconnect} className={styles.btn}>
          <LogoutBtn />
        </button>
      </div>
    </div>
  );
};

export default WalletWidget;
